<template>
  <div class="label">
    <CreateOrEditAdminTag
      :moduleList="moduleList"
      :salesmanRoleList="salesmanRoleList"
      ref="createOrEditDialog"
      @submitDialog="GetTableList"
    />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item>{{ l("标签") }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="HeaderButtons">
        <el-button
          v-if="$store.getters.checkPermission('admin_tag.add')"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="CreateItem()"
          >{{ l("新增") }}</el-button
        >
      </div>
    </div>
    <div class="PageContent">
      <el-tabs v-model="SearchData.module" type="card">
        <el-tab-pane
          v-for="item in moduleList"
          :key="item.id"
          :label="item.name"
          :name="item.id"
        >
        </el-tab-pane>
      </el-tabs>
      <el-table
        :data="TableList"
        :stripe="true"
        @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange"
      >
        <TableOperation
          :operationList="[
            {
              is_show: (row) => true,
              label: '编辑',
              command: 'EditItem',
            },
            {
              is_show: (row) =>
                false && $store.getters.checkPermission('admin_tag.delete'), //暂时不给删除
              label: '删除',
              command: 'DeleteItem',
            },
          ]"
          @handleOperation="HandleOperation"
        />

        <el-table-column prop="name" :label="l('名称')"></el-table-column>

        <el-table-column
          v-if="SearchData.module == 'pre_business'"
          :label="l('专属业务员')"
        >
          <template slot-scope="scope">
            {{
              $utils.listFilter(
                salesmanRoleList,
                scope.row.extra_params.manager_role_id,
                "display_name"
              )
            }}
          </template>
        </el-table-column>

        <el-table-column prop="order_index" label="优先级"></el-table-column>

        <el-table-column label="是否展示">
          <template slot-scope="scope">
            <span v-if="scope.row.is_hide">
              <i class="el-icon-close color-danger"></i>
            </span>
            <span v-else>
              <i class="el-icon-check color-success"></i>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="HandleSizeChange"
        @current-change="HandleCurrentChange"
        :current-page="CurrentPage"
        :page-sizes="PageSizeList"
        :page-size="PageSize"
        layout="total, prev, pager, next, jumper"
        :total="TotalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditAdminTag from "./operation/CreateOrEditAdminTag.vue";

export default {
  name: "Tag",
  components: {
    CreateOrEditAdminTag,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        module: "pre_business",
      },
      moduleList: [
        {
          id: "pre_business",
          name: "主营业务",
        },
        {
          id: "business_1",
          name: "企业类型",
        },
        {
          id: "forum",
          name: "论坛",
        },
        {
          id: "good_business",
          name: "优选好商",
        },
      ],
      salesmanRoleList: [],
    };
  },
  watch: {
    "SearchData.module"() {
      this.GetTableList(true);
    },
  },
  mounted() {
    this.axios
      .get("/api/role/", {
        params: {
          type: 3, //1注册用户 2前台 3后管
        },
      })
      .then((data) => {
        this.salesmanRoleList = data;
      });
  },
  methods: {
    GetTableList(resetPage) {
      this.TableList = [];

      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/admin_tag/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    CreateItem() {
      this.$refs.createOrEditDialog.Type = "Create";
      this.$refs.createOrEditDialog.Show({
        module: this.SearchData.module,
      });
    },
    DeleteItem(item) {
      console.log(item);
      this.$confirm(`是否删除标签${item.name}?`, "", {
        type: "warning",
      }).then(() => {
        this.axios.delete(`/api/admin_tag/${item.id}/`).then((response) => {
          this.GetTableList();
        });
      });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

